/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { STAGES_COLORS } from '@Constants/ElementConstants';
import RxStructureService from '@Services/RxStructureService';
import ReactReactionAdditionalInfoHelper from '@Components/Results/services/react-reaction-additional-info-helper.service';

export default class ReactionAdditionalDataCellComponent extends React.Component {
  constructor(props) {
    super(props);

    // eslint-disable-next-line react/destructuring-assignment
    this.value = this.props?.row?.cells?.[this.props?.index]?.value;
    this.defaultCellText = this.value?.join ? this.value?.join(', ') : this.value;
  }

  // eslint-disable-next-line class-methods-use-this
  getStageBgColor(row) {
    let stage = ReactReactionAdditionalInfoHelper.getStage(row);
    // eslint-disable-next-line no-plusplus
    stage--;

    return {
      backgroundColor: STAGES_COLORS[stage % STAGES_COLORS.length],
    };
  }

  viewSubstanceDetails(rowId) {
    const { databaseId } = this.props;
    RxStructureService.viewDetails(rowId, rowId, databaseId);
  }

  render() {
    const { cell, row } = this.props;
    return (
      <td
        className={`column-${cell?.cssid}
                            ${row?.leading ? 'leading' : ''}
                            ${row?.trailing ? 'trailing' : ''}`}>
        {cell?.id === 'stage' && (
          <InnerHTML
            tag="div"
            className="stage-data"
            html={row?.trailing ? '' : this.value}
            mode="escape"
            style={this.getStageBgColor(row)}
          />
        )}

        {cell?.id === 'role' && <InnerHTML tag="div" className="role-data" html={this.defaultCellText} mode="escape" />}

        {cell?.id === 'name' && (
          <>
            <InnerHTML tag="div" className="name-data" html={this.defaultCellText} mode="escape" />
            <button
              className="rx-btn rx-btn--tiny rx-btn--basic_link structure-details"
              onClick={this.viewSubstanceDetails?.bind(this, row?.id)}>
              <span className="rx-btn-text">
                <span className="rx-btn-text-container">Details</span>
              </span>
              <span className="rx-btn-icon">
                <i className="ss-upright" />
              </span>
            </button>
          </>
        )}

        {cell?.id !== 'stage' && cell?.id !== 'role' && cell?.id !== 'name' && (
          <InnerHTML tag="div" html={this.defaultCellText} mode="escape" />
        )}
      </td>
    );
  }
}

ReactionAdditionalDataCellComponent.propTypes = {
  row: PropTypes.object.isRequired,
  cell: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  databaseId: PropTypes.string.isRequired,
};
